<!--
 * @Descripttion:
 * @version:
 * @Author: lubaicen
 * @Date: 2020-08-29 10:31:33
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:19:39
-->
<template>
  <ux-form
    class="approval x-padding-x"
    ref="form"
    :data="formData"
    :rules="rules"
    label-width="80px"
    data-automation="approval"
    :colon="true"
    @close="close"
    @confirm="confirm"
  >
    <ux-form-item :label="$t('HT.unbindApply.name')">{{ data.name }}</ux-form-item>
    <ux-form-item :label="$t('HT.approval.flag')" prop="flag">
      <my-radio-group my-radio-group v-model="formData.flag" :list="list"></my-radio-group>
    </ux-form-item>
  </ux-form>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    },
    list: {
      type: Array,
      default: () => {
        return [
          {
            label: i18n.t('HT.options.approval1'),
            value: true
          },
          {
            label: i18n.t('HT.refuse'),
            value: false
          }
        ];
      }
    }
  },
  data() {
    return {
      formData: {
        id: this.data.id, // id
        flag: ''
      },
      rules: this.$rul.bindApi()
    };
  },

  methods: {
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
